import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "../i18n";
import { trackFormSubmission } from "../lib/consent";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export default function ContactForm({ compact = false, onSubmitted }) {
  const sfx = compact ? "-modal" : "";
  const { t } = useI18n();
  const navigate = useNavigate();
  const [values, setValues] = useState({ name: "", email: "", message: "" });
  const [errors, setErrors] = useState({});
  const [sending, setSending] = useState(false);

  const setField = (field) => (e) => {
    setValues((v) => ({ ...v, [field]: e.target.value }));
    setErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  const validate = () => {
    const next = {};
    if (values.name.trim().length < 2) next.name = t("form.errors.name");
    if (!EMAIL_RE.test(values.email.trim())) next.email = t("form.errors.email");
    if (values.message.trim().length < 10) next.message = t("form.errors.message");
    return next;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const next = validate();
    setErrors(next);
    if (Object.keys(next).length > 0) return;
    setSending(true);
    trackFormSubmission();
    if (onSubmitted) onSubmitted();
    window.setTimeout(() => {
      navigate("/thank_you");
    }, 250);
  };

  return (
    <form
      className={`contact-form${compact ? " is-compact" : ""}`}
      onSubmit={handleSubmit}
      noValidate
      data-testid={`contact-form${sfx}`}
    >
      <div className="field">
        <label htmlFor={`name-${compact ? "modal" : "page"}`}>{t("form.name")}</label>
        <input
          id={`name-${compact ? "modal" : "page"}`}
          type="text"
          value={values.name}
          onChange={setField("name")}
          placeholder={t("form.namePlaceholder")}
          autoComplete="name"
          data-testid={`form-name${sfx}`}
        />
        {errors.name && (
          <span className="field-error" data-testid={`error-name${sfx}`}>
            {errors.name}
          </span>
        )}
      </div>

      <div className="field">
        <label htmlFor={`email-${compact ? "modal" : "page"}`}>{t("form.email")}</label>
        <input
          id={`email-${compact ? "modal" : "page"}`}
          type="email"
          value={values.email}
          onChange={setField("email")}
          placeholder={t("form.emailPlaceholder")}
          autoComplete="email"
          data-testid={`form-email${sfx}`}
        />
        {errors.email && (
          <span className="field-error" data-testid={`error-email${sfx}`}>
            {errors.email}
          </span>
        )}
      </div>

      <div className="field">
        <label htmlFor={`message-${compact ? "modal" : "page"}`}>{t("form.message")}</label>
        <textarea
          id={`message-${compact ? "modal" : "page"}`}
          rows={compact ? 4 : 5}
          value={values.message}
          onChange={setField("message")}
          placeholder={t("form.messagePlaceholder")}
          data-testid={`form-message${sfx}`}
        />
        {errors.message && (
          <span className="field-error" data-testid={`error-message${sfx}`}>
            {errors.message}
          </span>
        )}
      </div>

      <button type="submit" className="btn btn-primary btn-block" disabled={sending} data-testid={`form-submit${sfx}`}>
        {sending ? t("form.sending") : t("form.submit")}
      </button>
      <p className="form-disclaimer">{t("form.disclaimer")}</p>
    </form>
  );
}
